"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUptTimeType = void 0;
const components_1 = require("../../../components");
const isUptTimeType = (timeType) => {
    return Object.values(components_1.UptPaycode).includes(timeType);
};
exports.isUptTimeType = isUptTimeType;
